import React from 'react';
import type { NcfType } from '../../../services/ncfService';

interface Props {
    ncfTypes: NcfType[];
    value: number | '';
    onChange: (value: number | '') => void;
    /**
     * Feature flag (task 5.7). When false, the selector is hidden —
     * the clinic has no RNC configured and fiscal invoicing is off.
     */
    hasRnc: boolean;
}

const NCF_TYPE_LABELS: Record<string, string> = {
    B01: 'Crédito Fiscal',
    B02: 'Consumidor Final',
    B14: 'Gubernamental',
    B15: 'Exportaciones',
};

/**
 * NCF type selector. Renders the dropdown when:
 * 1. The clinic has an RNC (feature flag — task 5.7)
 * 2. At least one NCF type is loaded from the catalog
 *
 * Otherwise renders nothing. Host components should not gate the
 * call themselves — this component encapsulates the rules.
 */
const NcfTypeSelector: React.FC<Props> = ({ ncfTypes, value, onChange, hasRnc }) => {
    if (!hasRnc || ncfTypes.length === 0) {
        return null;
    }

    return (
        <div className="mb-3" data-testid="ncf-type-selector">
            <label className="form-label form-label-sm">Tipo de Comprobante NCF</label>
            <select
                className="form-select form-select-sm"
                value={value === '' ? '' : String(value)}
                onChange={e => onChange(e.target.value ? Number(e.target.value) : '')}
            >
                <option value="">Sin NCF (REC-)</option>
                {ncfTypes.map(t => (
                    <option key={t.id} value={t.id}>
                        {t.code} — {NCF_TYPE_LABELS[t.code] ?? t.name}
                    </option>
                ))}
            </select>
            <small className="form-text text-muted">
                El sistema detecta automáticamente el tipo según la identificación del paciente
                (RNC → Crédito Fiscal, Cédula → Consumidor Final).
            </small>
        </div>
    );
};

export default NcfTypeSelector;
